import { Card, CardContent, styled } from '@mui/material';

export const CardStyled = styled(Card)(({ theme }) => ({
  width: '100%',
  color: theme.palette.common.white,
  background: theme.palette.primary.main,
  border: `1px solid ${theme.palette.secondary.dark}`,
}));

export const CardContentStyled = styled(CardContent)(({ theme }) => ({
  display: 'flex',
  justifyContent: 'space-between',
  height: '6rem',
  gap: '7rem',

  [theme.breakpoints.down('sm')]: {
    gap: '1rem',
    flexDirection: 'column',
    height: 'auto',
  },
}));
